(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nolvya-before-after-v2')) {
  customElements.define('nolvya-before-after-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.played = false;
      this.interacted = false;
      this.frame = 0;
      this.timer = 0;
      this.updateViewport = () => this.style.setProperty('--mm-ba-viewport', `${document.documentElement.clientWidth}px`);
      this.updateViewport();
      window.addEventListener('resize', this.updateViewport, { passive:true });
      this.range = this.querySelector('.mm-ba__range');
      this.scene = this.querySelector('.mm-ba__scene');
      if (!this.range || !this.scene) return;
      this.start = this.clamp(this.range.value);
      this.position = this.start;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.input = () => { this.stop(); this.setPosition(this.range.value); };
      this.interact = () => this.stop();
      this.pointerDown = event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.stop();
        this.pointer = event.pointerId;
        this.range.focus({ preventScroll:true });
        this.range.setPointerCapture(event.pointerId);
        this.point(event);
        event.preventDefault();
      };
      this.pointerMove = event => { if (event.pointerId === this.pointer) { this.point(event); event.preventDefault(); } };
      this.pointerUp = event => {
        if (event.pointerId !== this.pointer) return;
        if (event.type === 'pointerup') this.point(event);
        this.pointer = null;
        if (this.range.hasPointerCapture(event.pointerId)) this.range.releasePointerCapture(event.pointerId);
      };
      this.motionChange = () => {
        if (this.motion.matches) {
          this.cancelDemo();
          if (!this.interacted) this.setPosition(this.start);
        } else if (this.visible && !this.played && !this.interacted) this.demo();
      };
      this.range.addEventListener('input', this.input);
      this.range.addEventListener('pointerdown', this.pointerDown);
      this.range.addEventListener('pointermove', this.pointerMove);
      this.range.addEventListener('pointerup', this.pointerUp);
      this.range.addEventListener('pointercancel', this.pointerUp);
      this.range.addEventListener('keydown', this.interact);
      this.range.addEventListener('focus', this.interact);
      this.motion.addEventListener('change', this.motionChange);
      this.setPosition(this.start);
      if (this.dataset.animate !== 'false' && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.3;
          if (this.visible) {
            if (!this.played && !this.interacted && !this.motion.matches) this.demo();
          } else if (!this.interacted) {
            this.cancelDemo();
            this.setPosition(this.start);
          }
        }, { threshold:0.3 });
        this.observer.observe(this.scene);
      }
    }
    clamp(value) { return Math.max(0, Math.min(100, Number(value) || 0)); }
    setPosition(value) {
      this.position = this.clamp(value);
      this.range.value = String(this.position);
      this.style.setProperty('--mm-ba-position', `${this.position}%`);
    }
    point(event) {
      const bounds = this.scene.getBoundingClientRect();
      if (bounds.width) this.setPosition((event.clientX - bounds.left) / bounds.width * 100);
    }
    demo() {
      this.cancelDemo();
      const configuredFrom = this.clamp(this.dataset.hintFrom ?? 92);
      const from = this.dataset.hintDirection === 'left' ? Math.min(configuredFrom, 100 - configuredFrom) : Math.max(configuredFrom, 100 - configuredFrom);
      const duration = Math.max(800, Number(this.dataset.hintDuration) || 1600);
      this.setPosition(from);
      this.timer = window.setTimeout(() => {
        this.timer = 0;
        if (this.interacted || this.motion.matches || !this.isConnected || !this.visible) return;
        this.played = true;
        let started;
        const tick = now => {
          if (this.interacted || !this.isConnected) return;
          if (started === undefined) started = now;
          const progress = Math.min(1, (now - started) / duration);
          const eased = progress * progress * (3 - 2 * progress);
          this.setPosition(from + (this.start - from) * eased);
          this.frame = progress < 1 ? window.requestAnimationFrame(tick) : 0;
        };
        this.frame = window.requestAnimationFrame(tick);
      }, Math.max(0, Number(this.dataset.hintDelay) || 0));
    }
    cancelDemo() {
      window.clearTimeout(this.timer);
      window.cancelAnimationFrame(this.frame);
      this.timer = 0;
      this.frame = 0;
    }
    stop() {
      this.interacted = true;
      this.cancelDemo();
      this.observer?.disconnect();
    }
    disconnectedCallback() {
      this.connected = false;
      this.cancelDemo();
      window.removeEventListener('resize', this.updateViewport);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChange);
      this.range?.removeEventListener('input', this.input);
      this.range?.removeEventListener('pointerdown', this.pointerDown);
      this.range?.removeEventListener('pointermove', this.pointerMove);
      this.range?.removeEventListener('pointerup', this.pointerUp);
      this.range?.removeEventListener('pointercancel', this.pointerUp);
      this.range?.removeEventListener('keydown', this.interact);
      this.range?.removeEventListener('focus', this.interact);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvya-home-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nolvya-home-banner'))customElements.define('nolvya-home-banner',class extends HTMLElement{
 connectedCallback(){this.videos=Array.from(this.querySelectorAll('video'));if(!this.videos.length)return;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width:767px)');this.change=()=>this.sync();this.mobile.addEventListener('change',this.change);this.motion.addEventListener('change',this.change);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);}
 sync(){const selected=this.videos.find(v=>getComputedStyle(v.parentElement).display!=='none');this.videos.forEach(v=>{if(v!==selected||this.dataset.autoplay!=='true'||this.motion.matches||!this.visible)v.pause();else v.play().catch(()=>{});});}
 disconnectedCallback(){this.observer?.disconnect();this.videos?.forEach(v=>v.pause());this.mobile?.removeEventListener('change',this.change);this.motion?.removeEventListener('change',this.change);}
});

  } catch(e) { console.error(e); }
})();
})();
